var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.076,
    height: 41.076,
    viewBox: "0 0 41.076 41.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_back",
    transform: "translate(-349.063 -606.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_14354",
    "data-name": "Path 14354",
    transform: "translate(349.063 606.85)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.538,0A20.538,20.538,0,1,1,0,20.538,20.538,20.538,0,0,1,20.538,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.537841796875 2 C 15.58620262145996 2 10.93094253540039 3.928279876708984 7.429611206054688 7.429630279541016 C 3.928272247314453 10.93098068237305 2 15.58627128601074 2 20.53793144226074 C 2 25.48959159851074 3.928272247314453 30.14487075805664 7.429611206054688 33.64623260498047 C 10.93094253540039 37.1475830078125 15.58620262145996 39.07586288452148 20.537841796875 39.07586288452148 C 25.48947143554688 39.07586288452148 30.14473152160645 37.1475830078125 33.64607238769531 33.64623260498047 C 37.14741134643555 30.14487075805664 39.07568359375 25.48959159851074 39.07568359375 20.53793144226074 C 39.07568359375 15.58627128601074 37.14741134643555 10.93098068237305 33.64607238769531 7.429630279541016 C 30.14473152160645 3.928279876708984 25.48947143554688 2 20.537841796875 2 M 20.537841796875 0 C 31.88057136535645 0 41.07568359375 9.195140838623047 41.07568359375 20.53793144226074 C 41.07568359375 31.88071060180664 31.88057136535645 41.07586288452148 20.537841796875 41.07586288452148 C 9.195102691650391 41.07586288452148 0 31.88071060180664 0 20.53793144226074 C 0 9.195140838623047 9.195102691650391 0 20.537841796875 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11989",
    "data-name": "Group 11989",
    transform: "translate(362.936 621.068)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_242",
    "data-name": "Line 242",
    x1: 10.167,
    y2: 6.131,
    transform: "translate(0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_243",
    "data-name": "Line 243",
    x1: 10.167,
    y1: 6.508,
    transform: "translate(0 6.131)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.edb789d3177854da7fa4f341e0549223.svg";
export { ForwardRef as ReactComponent };